// extracted by mini-css-extract-plugin
export default {"button":"Button_button__yywli","primary":"Button_primary__biecz","secondary":"Button_secondary__d1rcl","textOnly":"Button_textOnly__n2DjR"};